import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { MUTATION_KEYS } from "./queryKeys";
import Api from "../api/Api";
import { IGetMetadata, IEnrichedMetadata, IDatasetBrief } from "../types/metadata";
import { IFWEPoint } from "../types/api";

interface CreateFullExtractionTasksParams {
  metadatas: IGetMetadata[];
  coordinates: number[];
  pointName: string;
  gridCellSize: string;
  waterDepth: string;
  datasetBriefs: IDatasetBrief[];
  fwePoints: IFWEPoint[];
  timeStepInterval?: number;
}

export default function useCreateFullExtractionTasksMutation(): UseMutationResult<
  IEnrichedMetadata[],
  Error,
  CreateFullExtractionTasksParams,
  unknown
> {
  return useMutation({
    mutationKey: [MUTATION_KEYS.service.createFullExtractionTasks],
    mutationFn: async ({
      metadatas,
      coordinates,
      pointName,
      gridCellSize,
      waterDepth,
      datasetBriefs,
      fwePoints,
      timeStepInterval
    }: CreateFullExtractionTasksParams): Promise<IEnrichedMetadata[]> => {
      try {
        return await Api.service.createFullExtractionTasks(
          metadatas,
          coordinates,
          pointName,
          gridCellSize, 
          waterDepth,
          datasetBriefs,
          fwePoints,
          timeStepInterval
        );
      } catch (error) {
        console.error('Error creating full extraction tasks:', error);
        throw error;
      }
    }
  });
}
